export default __webpack_public_path__ + "static/media/sport.c66721ee.wav";